import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Loader from "../../../../components/common/Loader";
import { toast } from "react-toastify";
import SnackbarToast from "../../../../components/common/SnackBar";
import {
  Button,
  Col,
  Form,
  Row,
  Stack,
  Container,
  Card,
  Spinner,
} from "react-bootstrap";
import { MachineDetailsSchema } from "../../../../validations/MachineDetails";
import { Formik } from "formik";
import InputText from "../../../../components/common/InputText";
import InputSelectAsync from "../../../../components/common/FormSelect";
import InputSelect from "../../../../components/common/InputSelect";
import MatDatePicker from "../../../../components/common/MatDatePicker";
import moment from "moment";
import InspectionArrow from "../../../../assets/images/inspection-arrow.svg";
import {
  getCriteriaAPI,
  getEquipmentDeviceAPI,
  updateInspectionAPI,
  getMachineAPI,
  getInspectionSheetFromEquipment,
  getListOfBoomJibConstruction,
} from "../../../../services/inspectionRequest";
import {
  inspectionTyppeWithoutKey,
  equipmentCategory,
  deviceLocationStatus,
  typeOfBargeWorkList,
  deviceLocationStatusWithoutKey,
} from "../../../../constants/constants";
import { nameBasedProtectedRoutes } from "../../../../router/protected";
import { getMachineListWithInprogress } from "services/userService";
import { AnyNaptrRecord } from "dns";

export const MachineDetails = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [inspectionData, setInspectionData] = useState<any>([]);
  const [inspectionMachine, setInspectionMachine] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [inspectionDatetime, setInspectionDatetime] = useState<any>(null);
  const [criteriaList, setCriteriaList] = useState([]);
  const [equipmentDevice, setEquipmentDevice] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const { machine_id, insptectionType, inspectionDate, inspectionTime } = props;
  const [fieldSheetList, setFieldSheetList] = useState([]);
  const [showQuadernial, setShowQuadernial] = useState(false);
  const [constructionDetailsList, setConstructionDetailsList] = useState<any>(
    []
  );
  const [isDisable, setIsDisable] = useState(false);
  const [machines, setMachines] = useState<any>([]);
  const [machineList, setMachineList] = useState<any>([]);
  const [showSnackBar, setshowSnackBar]: any = useState({
    show: false,
    message: "",
    severity: "",
  });
  const state = location.state;
  const worksiteChange = [
    { value: "Yes", key: "yes" },
    { value: "No", key: "no" },
  ];

  const serviceStatusTimeOfSurvey = [
    { value: "Lifting", key: "lifting" },
    { value: "Other", key: "other" },
  ];
  const currentDate = new Date();

  interface Inspection {
    inspection_datetime: string;
    inspection_type: string;
    job_location: string;
    criteria: number;
    make: string;
    device_id: string;
    model_number: string;
    equipment_type: any;
    serial_number: string;
    equipment_category: string;
    device_location_status: string;
    device_status: string;
    max_capacity: string;
    worksite_change: string;
    hours: string;
    machine_length: string;
    service_status_time_of_survey: string;
    other_details: string;
    construction_details: any;
    inspection_sheet: any;
    machine_id: string | number;
    inspection_id: string | number;
    is_quadranial: boolean;
    type_of_barge_work: string;
    existing_machine_id? : string | number
  }
  const quadrennialOptions = [
    { value: "Yes", key: true },
    { value: "No", key: false },
  ];
  const manipulateValue = (obj: any) => {
    
    return (
      (obj.make ? obj.make : "-") +
      "(" +
      (obj.device_id ? obj.device_id : "-") +
      "/" +
      (obj.model_number ? obj.model_number : "-") +
      "/" +
      (obj.serial_number ? obj.serial_number : "-") +
      ")"
    );
  };
const handleSelectedMachine = () =>{
  const selectedMachine = machines.find((obj) => obj.id === props.machine_id);

  const result = selectedMachine
    ? {
        key: props.machine_id,
        value: manipulateValue(selectedMachine),
      }
    : null;
    return result
}
  const initialValueObject = {
    existing_machine_id : "",
    machine_id: inspectionMachine.id,
    inspection_id: props.inspection_id,
    inspection_datetime: inspectionMachine?.Inspection
      ? moment(
          inspectionMachine?.Inspection?.inspection_date +
            " " +
            inspectionMachine?.Inspection?.job_time
        )
      : moment(inspectionDate + " " + inspectionTime),
    inspection_type: inspectionMachine.inspection_type
      ? inspectionMachine.inspection_type
      : "",
    job_location: inspectionMachine.job_location,
    criteria: inspectionMachine?.criteria ? inspectionMachine?.criteria : "",
    make: inspectionMachine.make ? inspectionMachine.make : "",
    device_id: inspectionMachine.device_id ? inspectionMachine.device_id : null,
    model_number: inspectionMachine.model_number
      ? inspectionMachine.model_number
      : "",
    // equipment_type: inspectionMachine.equipment_type_id
    //     ? inspectionMachine.equipment_type_id
    //     : "",
    equipment_type: inspectionMachine.equipment_type_id
      ? equipmentDevice.find(
          (obj) => obj.key === inspectionMachine.equipment_type_id
        )
      : "",
    serial_number: inspectionMachine.serial_number
      ? inspectionMachine.serial_number
      : "",
    equipment_category: inspectionMachine.equipment_category
      ? inspectionMachine.equipment_category
      : "",
    device_location_status: inspectionMachine.device_location_status
      ? inspectionMachine.device_location_status
      : "",
    device_status: inspectionMachine.device_status
      ? inspectionMachine.device_status
      : "",
    max_capacity: inspectionMachine.max_capacity
      ? inspectionMachine.max_capacity
      : "",
    worksite_change: inspectionMachine.worksite_change
      ? inspectionMachine.worksite_change
      : "",
    hours: inspectionMachine.hours ? inspectionMachine.hours : "",
    machine_length: inspectionMachine.machine_length
      ? inspectionMachine.machine_length
      : "",
    service_status_time_of_survey:
      inspectionMachine.service_status_time_of_survey
        ? inspectionMachine.service_status_time_of_survey
        : "",
    other_details: inspectionMachine.other_details
      ? inspectionMachine.other_details
      : "",
    // construction_details: inspectionMachine.construction_details
    //     ? inspectionMachine.construction_details
    //     : "",
    construction_details: inspectionMachine.construction_details
      ? constructionDetailsList.find(
          (obj) => obj.key === inspectionMachine.construction_details
        )
      : "",
    //       inspection_sheet: inspectionMachine.assign_equipment_sheet ? inspectionMachine.assign_equipment_sheet :"",
    inspection_sheet: inspectionMachine.assign_equipment_sheet
      ? fieldSheetList.find(
          (obj) => obj.key === inspectionMachine.assign_equipment_sheet
        )
      : "",
    is_quadranial: inspectionMachine.is_quadranial
      ? inspectionMachine.is_quadranial
      : false,
    type_of_barge_work: inspectionMachine.type_of_barge_work
      ? inspectionMachine.type_of_barge_work
      : "",
      selectedMachine :handleSelectedMachine()
  };

  // const inspectionSheet = [
  //     { value: "Inspection sheet first", key: "Inspection sheet first" },
  //     { value: "Inspection sheet second", key: "Inspection sheet second" },
  // ];


  const getUserAllMachine = async (userId: any) => {
    

    await getMachineListWithInprogress({ userId }).then(async (response) => {
      setMachines(response.data);

      const newData = await Promise.all(
        response.data.map(async (obj: any) => {
          const manipulatedValue = await manipulateValue(obj);
          return { key: obj.id, value: manipulatedValue };
        })
      );

      const uniqueArray = await Promise.all(
        Array.from(new Set(newData.map((a) => a.value.toLowerCase()))).map(
          (value) => {
            return newData.find(
              (a) => a.value.toLowerCase() === value.toLowerCase()
            );
          }
        )
      );

      setMachineList(uniqueArray);
      setLoading(false);

    }).catch(()=>{
      setLoading(false);

    });
  };

  const handleMachineAutoFill = (value, setFieldValue) => {
    if (machines.length) {
      const selectedMachine = machines.find((val) => val.id == value.key);
      setFieldValue("existing_machine_id",value.key)
      setFieldValue("make", selectedMachine.make);
      setFieldValue("device_id", selectedMachine.device_id);
      setFieldValue("model_number", selectedMachine.model_number);
      setFieldValue("serial_number", selectedMachine.serial_number);
      setFieldValue("selectedMachine", value)
      setIsDisable(true);
    }
  };
  const handleRestMachine = (setFieldValue) =>{
    setFieldValue("existing_machine_id","")
    setFieldValue("make", "");
    setFieldValue("device_id", "");
    setFieldValue("model_number", "");
    setFieldValue("serial_number", "");
    setFieldValue("selectedMachine", "")

    setIsDisable(!isDisable)
  }
  const loadData = async () => {
    try {
      const [
        criteriaResponse,
        equipmentResponse,
        machineResponse,
        fieldSheetResponse,
        constructionDetailResponse,
      ] = await Promise.all([
        getCriteriaAPI(),
        getEquipmentDeviceAPI(),
        getMachineAPI(props.machine_id),
        getInspectionSheetFromEquipment(),
        getListOfBoomJibConstruction(),
      ]);
      getUserAllMachine(machineResponse.user_id);
      
      setCriteriaList(criteriaResponse);
      setEquipmentDevice(equipmentResponse);
      setInspectionMachine(machineResponse);
      setConstructionDetailsList(constructionDetailResponse);
      const targetDate = machineResponse.quadranial_date
        ? new Date(machineResponse.quadranial_date)
        : new Date();
      const yearDiff = currentDate.getFullYear() - targetDate.getFullYear();
      const showDiv = yearDiff >= 4;
      setShowQuadernial(showDiv);
      const inspectionSheet = fieldSheetResponse.map((item) => ({
        value: item.equipment_name,
        key: item.id,
      }));
      setFieldSheetList(inspectionSheet);
      
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.machine_id) {
      loadData();
    }
  }, []);

  const handleSubmit = (values: Inspection) => {
    setBtnLoading(true);
    const formData = {
      inspectionData: {
        inspection_date: moment(values.inspection_datetime).format(
          "YYYY/MM/DD"
        ),
        inspection_time: moment(values.inspection_datetime).format("H:mm:ss"),
        inspection_id: values.inspection_id,
      },
      machineData: {
        machine_id: values.machine_id,
        inspection_type: values.inspection_type,
        job_location: values.job_location,
        criteria: values.criteria,
        make: values.make,
        device_id: values.device_id,
        model_number: values.model_number,
        serial_number: values.serial_number,
        equipment_type_id: values.equipment_type?.key,
        equipment_category: values.equipment_category,
        device_location_status: values.device_location_status,
        device_status: values.device_status,
        max_capacity: values.max_capacity,
        worksite_change: values.worksite_change,
        hours: values.hours,
        machine_length: values.machine_length,
        service_status_time_of_survey: values.service_status_time_of_survey,
        other_details: values.other_details,
        construction_details: values.construction_details?.key,
        is_quadranial: values.is_quadranial,
        type_of_barge_work: values.type_of_barge_work,
      },
      field_sheet_id: values.inspection_sheet.key,
      existing_machine_id : values.existing_machine_id
    };

    updateInspectionAPI(formData)
      .then((response) => {
        setBtnLoading(false);
        navigate(nameBasedProtectedRoutes.inspectionForm.path, {
          state: {
            model_number: inspectionMachine.model_number,
            serial_number: inspectionMachine.serial_number,
            inspection_data_sheet_id: response.data.inspection_data_sheet_id,
            inspection_id: inspectionData.id,
            machine_id: response.data.id,
            inspectionType: values.inspection_type,
          },
        });
      })
      .catch((error) => {
        setBtnLoading(false);
        const msg = error?.response?.data?.message || error?.message || "Invalid request";
        toast.error(msg);
      });

    //setBtnLoading(true);
  };

  interface InspectionTypeInterface {
    key: string;
    value: string;
  }
  const [worksiteChangeHide, setWorksiteChangeHide] = useState(true);
  const handleWorksiteChanges = async (event, setFieldValue) => {
    setWorksiteChangeHide(false);
    const selValue = event.target.value;
    if (
      selValue == deviceLocationStatusWithoutKey.changesWorksite ||
      selValue == deviceLocationStatusWithoutKey.onbarge
    ) {
      setFieldValue("worksite_change", "yes");
    } else {
      setFieldValue("worksite_change", "no");
    }
    await Promise.resolve();
    setWorksiteChangeHide(true);
  };

  return (
    <>
      {/* Content */}

      <div className="">
        {!loading ? (
          <Formik
            validationSchema={MachineDetailsSchema}
            initialValues={initialValueObject}
            onSubmit={handleSubmit}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              setFieldValue,
              setFieldError,
              setValues,
            }) => (
              <>
                <Container className="">
                  <Row>
                    <Col md={12} lg={12} className="inspector-tab-p-0">
                      <Card className="border-0 mb-3">
                        <Card.Body className="br-10 p-4">
                          <div className="col-xl-12">
                            <Row>
                              <Col md="12">
                                <h2 className="fs-16 fw-bold border-left-6 mb-4 text-uppercase">
                                  Inspection Details
                                </h2>
                                <pre></pre>
                              </Col>
                            </Row>
                            <Row>
                              <Col
                                md="6"
                                className="inspectorFixDate inspector-start-date inspector-date-icon"
                              >
                                <MatDatePicker
                                  controlId="inspection_datetime"
                                  label="Inspection date"
                                  touched={touched.inspection_datetime}
                                  errorsField={errors.inspection_datetime}
                                  handleChange={(e: any) => {
                                    setFieldValue(
                                      "inspection_datetime",
                                      moment(e)
                                    );
                                  }}
                                  value={values.inspection_datetime}
                                  setValue={setInspectionDatetime}
                                />
                              </Col>
                              <Col md="6">
                                <InputSelect
                                  controlId="inspection_type"
                                  label="Inspection Type"
                                  placeholder="Inspection Type"
                                  touched={touched.inspection_type}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  errorsField={errors.inspection_type}
                                  value={values.inspection_type}
                                  options={insptectionType}
                                  readOnly={false}
                                />
                              </Col>
                            </Row>

                            <Row>
                              <Col md="6">
                                <InputText
                                  controlId="job_location"
                                  label="Job location"
                                  placeholder="Job location"
                                  touched={touched.job_location}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  errorsField={errors.job_location}
                                  value={values.job_location}
                                />
                              </Col>
                              <Col md="6">
                                <InputSelect
                                  controlId="criteria"
                                  label="Inspection criteria"
                                  placeholder="Inspection criteria"
                                  touched={touched.criteria}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  errorsField={errors.criteria}
                                  value={values.criteria}
                                  options={criteriaList}
                                  readOnly={false}
                                />
                              </Col>
                            </Row>
                            {values.inspection_type ==
                              inspectionTyppeWithoutKey.Maritime &&
                              showQuadernial && (
                                <Row>
                                  <Col md="6">
                                    <InputSelect
                                      controlId="is_quadranial"
                                      placeholder=" Select  quadranial"
                                      label="Quadranial"
                                      touched={touched.is_quadranial}
                                      handleBlur={handleBlur}
                                      handleChange={handleChange}
                                      errorsField={errors.is_quadranial}
                                      value={values.is_quadranial}
                                      options={quadrennialOptions}
                                      readOnly={false}
                                    />
                                  </Col>
                                </Row>
                              )}
                          </div>

                          <div className="col-xl-12">
                            <Row>
                              <Col md="6">
                                <h2 className="fs-16 fw-bold border-left-6 mb-4 text-uppercase">
                                  Machine Details
                                </h2>
                              </Col>
                              <Col md="6">
                                <div className="d-flex justify-content-end ">
                                 {isDisable  && <div
                                    className="pt-2 pointer-cursor "
                                    title="Clear Decal Information"
                                    onClick={()=>handleRestMachine(setFieldValue)}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      height="1em"
                                      viewBox="0 0 512 512"
                                    >
                                      <path d="M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"></path>
                                    </svg>
                                    &nbsp; Reset
                                  </div>}
                                  <InputSelectAsync
                                    className="w-80"
                                    // label="Equipment type"
                                    placeholder="Select Existing Machine"
                                    options={machineList}
                                    getOptionLabel={(option) => option.value}
                                    getOptionValue={(option) => option.key}
                                    onChange={(name, value) => {
                                      handleMachineAutoFill(
                                        value,
                                        setFieldValue
                                      );
                                    }}
                                    name="selectedMachine"
                                    value={values.selectedMachine}
                                  
                                  />
                                
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <InputText
                                  controlId="make"
                                  label="Make"
                                  placeholder="Make"
                                  disabled={isDisable}
                                  touched={touched.make}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  errorsField={errors.make}
                                  value={values.make}
                                />
                              </Col>
                              <Col md="6">
                                <InputText
                                  controlId="device_id"
                                  label="Device ID"
                                  disabled={isDisable}
                                  placeholder="Device ID"
                                  touched={touched.device_id}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  errorsField={errors.device_id}
                                  value={values.device_id}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <InputText
                                  controlId="model_number"
                                  label="Model"
                                  disabled={isDisable}
                                  placeholder="Model"
                                  touched={touched.model_number}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  errorsField={errors.model_number}
                                  value={values.model_number}
                                />
                              </Col>
                              <Col md="6">
                                {/* <InputSelect
                                                                    controlId="equipment_type"
                                                                    label="Equipment type"
                                                                    placeholder="Equipment type"
                                                                    touched={touched.equipment_type}
                                                                    handleBlur={handleBlur}
                                                                    handleChange={handleChange}
                                                                    errorsField={errors.equipment_type}
                                                                    value={values.equipment_type}
                                                                    options={equipmentDevice}
                                                                    readOnly={false}
                                                                />
                                                                 */}
                              <div className="position-relative">
                                {values.equipment_type && <span className="floatingLabel">Equipment type</span>}
                                <InputSelectAsync
                                  className="mb-5"
                                  label=""
                                  placeholder="Equipment type"
                                  name="equipment_type"
                                  options={equipmentDevice}
                                  getOptionLabel={(option) => option.value}
                                  getOptionValue={(option) => option.key}
                                  onChange={(name, value) => {
                                    setFieldValue(name, value);
                                  }}
                                  touched={touched.equipment_type}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  error={errors.equipment_type}
                                  value={values.equipment_type}
                                />
                              </div>
                               
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <InputText
                                  controlId="serial_number"
                                  label="Serial No."
                                  disabled={isDisable}
                                  placeholder="Serial No."
                                  touched={touched.serial_number}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  errorsField={errors.serial_number}
                                  value={values.serial_number}
                                />
                              </Col>
                              <Col md="6">
                                <InputSelect
                                  controlId="equipment_category"
                                  label="Equipment Category"
                                  placeholder="Equipment Category"
                                  touched={touched.equipment_category}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  errorsField={errors.equipment_category}
                                  value={values.equipment_category}
                                  options={equipmentCategory}
                                  readOnly={false}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <InputSelect
                                  controlId="device_location_status"
                                  label="Device location status"
                                  placeholder="Device location status"
                                  touched={touched.device_location_status}
                                  handleBlur={handleBlur}
                                  //   handleChange={handleChange}
                                  handleChange={(e) => {
                                    handleChange(e);
                                    handleWorksiteChanges(e, setFieldValue);
                                  }}
                                  errorsField={errors.device_location_status}
                                  value={values.device_location_status}
                                  options={deviceLocationStatus}
                                  readOnly={false}
                                />
                              </Col>

                              {values.device_location_status !=
                                "Changes Worksite" && (
                                <Col md="6">
                                  <InputText
                                    controlId="device_status"
                                    label="Device status"
                                    placeholder="Device status"
                                    touched={touched.device_status}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.device_status}
                                    value={values.device_status}
                                  />
                                </Col>
                              )}

                              {values.device_location_status == "On Barge" && (
                                <Col md="6">
                                  <InputSelect
                                    controlId="type_of_barge_work"
                                    label="Type of barge work"
                                    placeholder="Type of barge work"
                                    touched={touched.type_of_barge_work}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.type_of_barge_work}
                                    value={values.type_of_barge_work}
                                    options={typeOfBargeWorkList}
                                    readOnly={false}
                                  />
                                </Col>
                              )}
                            </Row>
                          </div>

                          <div className="col-xl-12">
                            <Row>
                              <Col md="12">
                                <h2 className="fs-16 fw-bold border-left-6 mb-4 text-uppercase">
                                  MACHINE CONFIGURATION
                                </h2>
                              </Col>
                            </Row>

                            <Row>
                              <Col md="4">
                                <InputText
                                  controlId="max_capacity"
                                  label="Max capacity"
                                  placeholder="Max capacity"
                                  touched={touched.max_capacity}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  errorsField={errors.max_capacity}
                                  value={values.max_capacity}
                                />
                              </Col>
                              <Col md="4">
                                {worksiteChangeHide && (
                                  <InputSelect
                                    controlId="worksite_change"
                                    label="Worksite changes"
                                    placeholder="Worksite changes"
                                    touched={touched.worksite_change}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.worksite_change}
                                    value={values.worksite_change}
                                    options={worksiteChange}
                                    readOnly={true}
                                  />
                                )}
                              </Col>
                              <Col md="4">
                                <InputText
                                  controlId="hours"
                                  label="Hours"
                                  placeholder="Hours"
                                  touched={touched.hours}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  errorsField={errors.hours}
                                  value={values.hours}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col md="4">
                                <InputText
                                  controlId="machine_length"
                                  label="Boom & jib length at the time of survey"
                                  placeholder="Boom & jib length at the time of survey"
                                  touched={touched.machine_length}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  errorsField={errors.machine_length}
                                  value={values.machine_length}
                                />
                              </Col>
                              <Col md="4">
                                <InputSelect
                                  controlId="service_status_time_of_survey"
                                  label="Service Status"
                                  placeholder="Service Status"
                                  touched={
                                    touched.service_status_time_of_survey
                                  }
                                  handleBlur={handleBlur}
                                  handleChange={(e) => {
                                    handleChange(e);
                                    if (e.target.value == "other") {
                                      setFieldError(
                                        "other_details",
                                        "Other is required"
                                      );
                                    }
                                  }}
                                  errorsField={
                                    errors.service_status_time_of_survey
                                  }
                                  value={values.service_status_time_of_survey}
                                  options={serviceStatusTimeOfSurvey}
                                  readOnly={false}
                                />
                              </Col>
                              {values.service_status_time_of_survey ==
                                "other" && (
                                <Col md="4">
                                  <InputText
                                    controlId="other_details"
                                    label="Others"
                                    placeholder="Others"
                                    touched={touched.other_details}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.other_details}
                                    value={values.other_details}
                                  />
                                </Col>
                              )}
                            </Row>
                            <Row>
                              <Col md="12">
                                {/* <InputText
                                                                    controlId="construction_details"
                                                                    label="Boom & jib construction"
                                                                    placeholder="Boom & jib construction"
                                                                    touched={touched.construction_details}
                                                                    handleBlur={handleBlur}
                                                                    handleChange={handleChange}
                                                                    errorsField={errors.construction_details}
                                                                    value={values.construction_details}
                                                                /> */}
                                <InputSelectAsync
                                  className=""
                                  // label="Icon"
                                  placeholder="Boom & jib construction"
                                  name="construction_details"
                                  options={constructionDetailsList}
                                  getOptionLabel={(option) => option.value}
                                  getOptionValue={(option) => option.key}
                                  onChange={(name, value) => {
                                    setFieldValue(name, value);
                                  }}
                                  touched={touched.construction_details}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  error={errors.construction_details}
                                  value={values.construction_details}
                                />
                              </Col>
                            </Row>
                          </div>
                          <div className="col-xl-12">
                            <Row>
                              <Col md="12">
                                <h2 className="fs-16 fw-bold border-left-6 mb-4 text-uppercase">
                                  SELECT INSPECTION SHEET
                                </h2>
                              </Col>
                            </Row>

                            <Row>
                              <Col md="6">
                                {/* <InputSelect
                                                                    controlId="inspection_sheet"
                                                                    label="Inspection sheet"
                                                                    placeholder="Inspection sheet"
                                                                    touched={touched.inspection_sheet}
                                                                    handleBlur={handleBlur}
                                                                    handleChange={handleChange}
                                                                    errorsField={errors.inspection_sheet}
                                                                    value={values.inspection_sheet}
                                                                    options={fieldSheetList}
                                                                    readOnly={false}
                                                                /> */}
                                <InputSelectAsync
                                  className=""
                                  // label="Icon"
                                  placeholder="Inspection sheet"
                                  name="inspection_sheet"
                                  options={fieldSheetList}
                                  getOptionLabel={(option) => option.value}
                                  getOptionValue={(option) => option.key}
                                  onChange={(name, value) => {
                                    setFieldValue(name, value);
                                  }}
                                  touched={touched.inspection_sheet}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  error={errors.inspection_sheet}
                                  value={values.inspection_sheet}
                                />
                              </Col>
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Container>

                <div className="d-flex justify-content-end inspector-footer pt-3 pb-3 pe-3 ps-3">
                  <Container>
                    <Row>
                      <Col sm="12" className="d-flex justify-content-end">
                        {btnLoading ? (
                          <Button
                            disabled={true}
                            variant="primary"
                            className="btn btn-primary my-1 fw-semibold  wait-cursor  "
                          >
                            <Spinner size="sm" />
                          </Button>
                        ) : (
                          <Button
                            type="submit"
                            variant="primary"
                            onClick={(e) => handleSubmit()}
                            className="btn btn-primary my-1 fw-semibold"
                          >
                            Next
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </Container>
                </div>
              </>
            )}
          </Formik>
        ) : (
          ""
        )}
      </div>

      <Loader isLoading={loading} />
    </>
  );
};
